import { render, staticRenderFns } from "./IntellectualPropertyStatement.vue?vue&type=template&id=4352e76e&scoped=true&"
import script from "./IntellectualPropertyStatement.vue?vue&type=script&lang=js&"
export * from "./IntellectualPropertyStatement.vue?vue&type=script&lang=js&"
import style0 from "./IntellectualPropertyStatement.vue?vue&type=style&index=0&id=4352e76e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4352e76e",
  null
  
)

export default component.exports